// extracted by mini-css-extract-plugin
module.exports = {"altText":"VideoAltText_altText__eLALj"};